import React, { FunctionComponent } from 'react';
import { Duration, TimeUnit } from '../../../types/__generated__';

export type FormattedDurationProps = { value: Duration };

const MILLISECONDS_IN_24_HOURS = 24 * 60 * 60 * 1000;

function getTimeString(
  hoursValue: number,
  minutesValue: number,
  secondsValue: number,
) {
  const isHoursAndMinutes =
    hoursValue > 0 || (hoursValue === 0 && minutesValue === 0);

  const isOnlySeconds = hoursValue === 0 && minutesValue === 0;

  const formatter = Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });

  const h = formatter.format(hoursValue);
  const m = formatter.format(minutesValue);
  const s = formatter.format(secondsValue);

  if (isOnlySeconds) {
    return secondsValue > 0 ? `${s}s` : '0m';
  }

  return isHoursAndMinutes ? `${h}h ${m}m` : `${m}m ${s}s`;
}

export const FormattedDuration: FunctionComponent<FormattedDurationProps> = ({
  value: { unit, value },
}) => {
  const milliseconds = unit === TimeUnit.Seconds ? value * 1000 : value;
  const days = Math.floor(milliseconds / MILLISECONDS_IN_24_HOURS);
  const date = new Date(milliseconds);
  return (
    <>
      {getTimeString(
        days * 24 + date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
      )}
    </>
  );
};
